import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  CssBaseline,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { allIcons, appLogo } from "../../assets";
import appcolors from "../../constants/Colors";
import { setSelectedBranch } from "../../lib/slices/selectedBranch";
import { ClientRoutes } from "../../routes";
import BranchMenu from "../MenuDropDown/BranchMenu";
import ProfileMenu from "../MenuDropDown/ProfileMenu";
import { AppBar, Drawer, DrawerHeader } from "./DrawerTheme";
import { Chat } from "@mui/icons-material";

const NavigationDrawer = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { branchesByBusiness } = useSelector((state) => state.branchSlices);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const { pathname } = location;
  const [open, setOpen] = useState(false);
  const [routeData, setRouteData] = useState([]);
  const { user } = useSelector((state) => state.user);
  const { userRoutes } = useSelector((state) => state.routes);

  useEffect(() => {
    if (user?.role === "business") {
      setRouteData(ClientRoutes);
    } else {
      const tempArr = userRoutes?.map((item) => {
        const route = ClientRoutes.find((route) => route.id === item?.id);
        return route;
      });
      setRouteData(tempArr);
    }
  }, [user, userRoutes]);

  const handleDrawerOpen = () => {
    setOpen(false);
  };

  const returnActive = (val, path) => {
    if (val == path) {
      return true;
    } else {
      return false;
    }
  };

  const handleChangeBranch = (e, selectedBranchId) => {
    dispatch(setSelectedBranch([]));
    const selectedBranchData = branchesByBusiness?.find(
      (branch) => branch._id === selectedBranchId
    );
    if (selectedBranchId?.length == 24) {
      dispatch(setSelectedBranch([selectedBranchData?._id]));
    } else {
      dispatch(setSelectedBranch(selectedBranchId));
    }
  };

  return (
    <Box display={"flex"} bgcolor={"#F5F5F5"} minHeight={"100vh"}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar
          sx={{
            minHeight: "inherit !important",
            justifyContent: "flex-end",
          }}
        >
          <Stack gap={2} direction={"row"} mr={3}>
            <Tooltip title="Customer support">
              <IconButton
                onClick={() => navigate("/dashboard/customer-support")}
                sx={{
                  p: 0,
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <img src={allIcons.chatIcon} alt={"icon"} width={30} />
              </IconButton>
            </Tooltip>
          </Stack>

          {location?.pathname !== "/dashboard/branches" &&
            location?.pathname !== "/dashboard/settings" &&
            branchesByBusiness?.length !== 0 && (
              <Stack
                p={"8px 16px"}
                gap={1}
                minWidth={200}
                direction={"row"}
                bgcolor={appcolors.white}
                boxShadow={"2px 2px 10px 0px rgb(198, 208, 219)"}
                alignItems={"center"}
                borderRadius={2}
                mr={3}
              >
                <BranchMenu
                  data={branchesByBusiness}
                  business={user?.businessId}
                  selectedBranch={selectedBranch || []}
                  onChange={(e, selectedBranchId) =>
                    handleChangeBranch(e, selectedBranchId)
                  }
                />
              </Stack>
            )}
          <ProfileMenu />
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        open={open}
        sx={{
          "& .MuiPaper-root": {
            "&::-webkit-scrollbar": {
              // display:"none",
              width: "4px",
              height: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: appcolors.slateGrey,
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: appcolors.secondary,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: appcolors.white,
            },
          },
        }}
      >
        <DrawerHeader>
          <Typography
            mt={0.5}
            variant="h3"
            fontSize={"1.813rem"}
            fontWeight={"600"}
            textAlign={"center"}
            color={appcolors.redOrange}
          >
            LOBA
          </Typography>
        </DrawerHeader>
        <Typography
          mt={0.5}
          variant="h3"
          fontSize={"0.813rem"}
          fontWeight={"600"}
          textAlign={"center"}
          color={"#868E96"}
        >
          MAIN MENU
        </Typography>
        <List disablePadding sx={{ mt: 2, p: "3px" }}>
          {routeData.map((val, index) => {
            let isMatched = returnActive(val.path, pathname);
            return (
              <ListItem
                key={index}
                disablePadding
                sx={{
                  mb: "5px",
                  display: "block",
                  borderRadius: "10px",
                  backgroundColor: isMatched
                    ? appcolors.primary
                    : "transparent",
                }}
              >
                <ListItemButton
                  disableRipple
                  onClick={() => navigate(val.path)}
                  sx={{
                    minHeight: 60,
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "0.3s",
                    borderRadius: "10px",

                    "&:hover": {
                      ...(!isMatched && { backgroundColor: "#FDEEE6" }),
                    },
                  }}
                >
                  <img
                    src={isMatched ? val.iconActive : val.icon}
                    alt={val.name}
                    width={25}
                    style={{ mb: 1 }}
                  />
                  <ListItemText
                    primary={val.name}
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontSize: "0.75rem",
                        transition: "0.3s",
                        color: isMatched ? appcolors.white : appcolors.black,
                        whiteSpace: "break-spaces",
                      },
                      textAlign: "center",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Drawer>

      {/* rendering components */}
      <Box
        component="main"
        sx={{ flexGrow: 1, p: "24px 1rem", overflow: "auto" }}
      >
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
};

export default NavigationDrawer;
